import { useScrollLock } from '@vueuse/core';

import { stateFactory } from '@/utils/state';

export const useGlobalSidebar = () => {
  const isOpen = stateFactory.create<boolean>('globalSidebar', false);
  const background = computed(() => (document ? document.body : undefined));
  const isBackgroundLocked = useScrollLock(background);

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  watch([isOpen], () => {
    isBackgroundLocked.value = isOpen.value; // GlobalSidebarが開いている間は、背景をスクロールできないようにする
  });

  return { isOpen, open, close };
};
